export default __webpack_public_path__ + "4387f755bbfd4b3686bd5c26e4577ecf.ttf";